<template>
  <div>
    <h3 class="text-lg font-semibold text-gray-700 mb-6">Progreso del Mes</h3>
    
    <div v-if="estadisticas && periodo">
      <!-- Gráfica de dona/círculo -->
      <div class="flex flex-col lg:flex-row items-center gap-8">
        <!-- Círculo de progreso -->
        <div class="relative w-64 h-64">
          <svg class="transform -rotate-90 w-64 h-64">
            <!-- Círculo de fondo -->
            <circle
              cx="128"
              cy="128"
              r="120"
              stroke="#e5e7eb"
              stroke-width="16"
              fill="none"
            />
            <!-- Círculo de progreso -->
            <circle
              cx="128"
              cy="128"
              r="120"
              :stroke="colorProgreso"
              stroke-width="16"
              fill="none"
              :stroke-dasharray="circunferencia"
              :stroke-dashoffset="offset"
              stroke-linecap="round"
              class="transition-all duration-1000 ease-out"
            />
          </svg>
          <!-- Texto central -->
          <div class="absolute inset-0 flex flex-col items-center justify-center">
            <span :class="`text-5xl font-bold ${colorTexto}`">
              {{ estadisticas.porcentaje_cumplimiento.toFixed(1) }}%
            </span>
            <span class="text-gray-500 text-sm mt-2">Cumplimiento</span>
          </div>
        </div>

        <!-- Información detallada -->
        <div class="flex-1">
          <div class="space-y-4">
            <!-- Pedidos a tiempo -->
            <div class="flex items-center justify-between p-4 bg-green-50 rounded-lg">
              <div class="flex items-center">
                <div class="w-4 h-4 bg-green-500 rounded-full mr-3"></div>
                <span class="text-gray-700 font-medium">Pedidos a Tiempo</span>
              </div>
              <div class="text-right">
                <p class="text-2xl font-bold text-green-600">{{ estadisticas.cotizaciones_a_tiempo }}</p>
                <p class="text-sm text-gray-500">
                  {{ calcularPorcentaje(estadisticas.cotizaciones_a_tiempo, estadisticas.total_cotizaciones) }}%
                </p>
              </div>
            </div>

            <!-- Pedidos retrasados -->
            <div class="flex items-center justify-between p-4 bg-red-50 rounded-lg">
              <div class="flex items-center">
                <div class="w-4 h-4 bg-red-500 rounded-full mr-3"></div>
                <span class="text-gray-700 font-medium">Pedidos Retrasados</span>
              </div>
              <div class="text-right">
                <p class="text-2xl font-bold text-red-600">{{ estadisticas.cotizaciones_retrasadas }}</p>
                <p class="text-sm text-gray-500">
                  {{ calcularPorcentaje(estadisticas.cotizaciones_retrasadas, estadisticas.total_cotizaciones) }}%
                </p>
              </div>
            </div>

            <!-- Meta -->
            <div class="flex items-center justify-between p-4 bg-blue-50 rounded-lg border-2 border-blue-200">
              <div class="flex items-center">
                <svg class="w-6 h-6 text-blue-600 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"></path>
                </svg>
                <span class="text-gray-700 font-medium">Meta Requerida</span>
              </div>
              <div class="text-right">
                <p class="text-2xl font-bold text-blue-600">{{ estadisticas.meta_requerida }}%</p>
                <p class="text-sm text-gray-500">
                  Tolerancia: {{ estadisticas.tolerancia_permitida }}%
                </p>
              </div>
            </div>

            <!-- Estado -->
            <div :class="estadoClases" class="p-4 rounded-lg border-2">
              <div class="flex items-center">
                <svg v-if="cumpleMeta" class="w-6 h-6 mr-3" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
                </svg>
                <svg v-else class="w-6 h-6 mr-3" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
                </svg>
                <span class="font-semibold">
                  {{ cumpleMeta ? '¡Bono en camino!' : 'Bono en riesgo' }}
                </span>
              </div>
              <p class="text-sm mt-2 ml-9">
                {{ mensajeEstado }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div v-else class="text-center py-8 text-gray-500">
      No hay datos disponibles
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'GraficaProgreso',
  props: {
    estadisticas: {
      type: Object,
      default: null,
    },
    periodo: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    // Constantes para el círculo SVG
    const radio = 120;
    const circunferencia = computed(() => 2 * Math.PI * radio);
    
    // Offset para el progreso del círculo
    const offset = computed(() => {
      if (!props.estadisticas) return circunferencia.value;
      const porcentaje = props.estadisticas.porcentaje_cumplimiento;
      return circunferencia.value - (porcentaje / 100) * circunferencia.value;
    });

    // Color del progreso basado en el cumplimiento
    const colorProgreso = computed(() => {
      if (!props.estadisticas) return '#9ca3af';
      
      const cumplimiento = props.estadisticas.porcentaje_cumplimiento;
      const meta = props.estadisticas.meta_requerida;
      
      if (cumplimiento >= meta) return '#10b981'; // verde
      if (cumplimiento >= meta - 5) return '#f59e0b'; // amarillo
      return '#ef4444'; // rojo
    });

    const colorTexto = computed(() => {
      if (!props.estadisticas) return 'text-gray-600';
      
      const cumplimiento = props.estadisticas.porcentaje_cumplimiento;
      const meta = props.estadisticas.meta_requerida;
      
      if (cumplimiento >= meta) return 'text-green-600';
      if (cumplimiento >= meta - 5) return 'text-yellow-600';
      return 'text-red-600';
    });

    const cumpleMeta = computed(() => {
      if (!props.estadisticas) return false;
      return props.estadisticas.porcentaje_cumplimiento >= props.estadisticas.meta_requerida;
    });

    const estadoClases = computed(() => {
      if (cumpleMeta.value) {
        return 'bg-green-50 border-green-200 text-green-800';
      }
      return 'bg-yellow-50 border-yellow-200 text-yellow-800';
    });

    const mensajeEstado = computed(() => {
      if (!props.estadisticas) return '';
      
      const cumplimiento = props.estadisticas.porcentaje_cumplimiento;
      const meta = props.estadisticas.meta_requerida;
      const diferencia = (cumplimiento - meta).toFixed(2);
      
      if (cumplimiento >= meta) {
        return `Excelente trabajo! Superaron la meta por ${diferencia}%. El equipo ganará el bono.`;
      }
      
      const pedidosFaltantes = Math.ceil(
        (props.estadisticas.total_cotizaciones * meta / 100) - props.estadisticas.cotizaciones_a_tiempo
      );
      
      return `Necesitan ${Math.abs(diferencia)}% más para alcanzar la meta. Aproximadamente ${pedidosFaltantes} pedido(s) más a tiempo.`;
    });

    const calcularPorcentaje = (valor, total) => {
      if (total === 0) return '0.0';
      return ((valor / total) * 100).toFixed(1);
    };

    return {
      circunferencia,
      offset,
      colorProgreso,
      colorTexto,
      cumpleMeta,
      estadoClases,
      mensajeEstado,
      calcularPorcentaje,
    };
  },
};
</script>
